import { Box, Flex, Text } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';

export const ProgressBar = ({ value, color }: { value: string | number; color?: string }) => {
  const [progress, setProgress] = useState<number>(0);
  const width = useMemo(() => (progress <= 50 ? `${progress}%` : `calc(${progress}% - 4ch)`), [progress]);

  useEffect(() => {
    setProgress(Number(value) || 0);
  }, [value]);

  return (
    <Flex position='relative' width='100%' alignItems='flex-end'>
      <Box
        width={width}
        minW='5px'
        borderRadius={10}
        background={color || 'brand.cyan'}
        h='11px'
        mr='.5ch'
        transition='width .25s ease-in-out'
      />

      <Text fontSize='sm' color={color || 'brand.cyan'} lineHeight='100%'>
        {progress}%
      </Text>
    </Flex>
  );
};
